import { useMutation } from '@apollo/client';
import { Vehicule, VehiculeInput } from '../../shared/types';
import { CITRIN_CREATE_VEHICULE, CreateVehiculeRequest, CreateVehiculeResponse } from '..';

type CreateMutationFunction = (request: VehiculeInput) => Promise<Vehicule>;
export const useCreateVehiculeMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateVehiculeResponse, CreateVehiculeRequest>(CITRIN_CREATE_VEHICULE);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createVehicule;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
